export interface IunImage {
    id:string,
    name:string,
    creditLink:string,
    filename:string,
    imageSmall:string,
    imageRegular:string,
    altDes: string
}

export enum Status {
    inital = "inital",
    searching = "searching",
    finished = "finished",
    error = "error"
}

export enum NotificationStatus {
    success = "success",
    error = "error",
    null = "null"
}

export interface Notification {
    notificationStatus:NotificationStatus | null, 
    show: boolean
}

export interface SideImageProps {
    bigImage: IunImage | null,
    status: Status,
    count: number,
    save: () => void,
    btnSaved: boolean,
    savedImages:IunImage[],
    isModal: boolean
}

export interface SearchResultsProps {
    ref: React.MutableRefObject<any>,
    onScroll: (e: any) => void,
    images: IunImage[],
    setBigImage: (value: React.SetStateAction<IunImage | null>) => void,
    bigImage:IunImage,
    status: Status,
    keyword: string
}

export interface SearchBoxProps {
    submitDisabled:boolean,
    searchBtnClick: () => void,
    onChange: (value: React.SetStateAction<string>) => void,
    resetSearch: (value:boolean) => void,
    keyword: string
}

export interface ResultLabelProps {
    keyword:string,
    status: Status,
    resultCount:number
}